import React from 'react';
import { Helmet } from 'react-helmet';

//Common application components
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import FooterCta from '@/components/FooterCta';

//Styles
import * as S from './styles.module.scss';

// type LayoutProps = {
//   children: ReactNode;
//   haveHeader?: boolean;
//   haveFooter?: boolean;
//   customHeader?: ReactNode;
//   customFooter?: ReactNode;
//   title: string;
//   meta: string;
// };

const Layout = ({
  children,
  haveHeader = true,
  haveFooter = true,
  customHeader = null,
  customFooter = null,
  title = '',
  meta = '',
}) => {
  return (
    <>
      {haveHeader && (customHeader ? customHeader : <Header />)}
      <Helmet>
        <html lang="pt-BR" />
        <title>{title} | Simples Já Contabilidade</title>
        <meta name="description" content={meta} />
      </Helmet>
      <main>
        <div className={S.container}>{children}</div>
      </main>
      {haveFooter &&
        (customFooter ? (
          customFooter
        ) : (
          <>
            <FooterCta />
            <Footer />
          </>
        ))}
    </>
  );
};

export default Layout;
